const Plattforms = [
	{
		text: "Newsletter",
		value: 1,
	},
	{
		text: "Facebook",
		value: 2,
	},
	{
		text: "Instagram",
		value: 3,
	},
	{
		text: "LinkedIn",
		value: 4,
	},
	{
		text: "Google Ads",
		value: 8,
	},
	{
		text: "YouTube",
		value: 5,
	},
];

export default Plattforms;
